import { defaultIcon, selectedIcon } from "./markerIcons";
import { restoreMarkerIcons } from "./restoreMarkerIcons";

export function createMarker(store: any, map: google.maps.Map, markers: google.maps.Marker[], bounds: google.maps.LatLngBounds) {
    if (!store.lat || !store.lng) return;

    const position = { lat: parseFloat(store.lat), lng: parseFloat(store.lng) };

    const marker = new google.maps.Marker({
        map,
        position,
        icon: defaultIcon,
    });

    marker.set("store", store);

    google.maps.event.addListener(marker, "click", async () => {
        restoreMarkerIcons(markers);

        marker.setIcon(selectedIcon);
        const pos = marker.getPosition();
        if (pos) {
            map.setCenter(pos);
        }

        const panel = document.getElementById("store-locator-panel") as HTMLElement;
        const panelContent = document.getElementById("panel-content") as HTMLElement;

        try {
            const apiUrlGetStore = window.StoreLocatorSettings?.apiUrlGetStore;
            if (!apiUrlGetStore) throw new Error("StoreLocatorSettings.apiUrlGetStore non défini");

            const response = await fetch(apiUrlGetStore + store.id);
            if (!response.ok) throw new Error("Store not found");

            const data = await response.json();
            panelContent.innerHTML = data.html;
            panel.classList.add("visible");
        } catch (error) {
            console.error(error);
            panelContent.innerHTML = "<p>Impossible de charger ce store.</p>";
        }
    });

    bounds.extend(position);
    markers.push(marker);
}
